export default {
  infoMessageMins: 'Auto-save log in {delayTime} minutes...',
  infoMessageMin: 'Auto-save log in {delayTime} minute...',
  infoMessageSecs: 'Auto-save log in {delayTime} seconds...',
  infoMessageSec: 'Auto-save log in {delayTime} second...',
} as const;
